<template>
  <q-card bordered flat>
    <q-card-section v-if="label || $slots.label" class="title row items-center justify-end gap-1 text-uppercase q-py-xs q-px-md">
      <div class="text-weight-bold" :class="{ 'text-subtitle1': !bigTitle, 'text-h6': bigTitle }">
        <slot name="label">
          {{ label }}
        </slot>
      </div>
      <app-button v-if="expandable" :icon="expanded ? 'expand_less' : 'expand_more'" dense flat @click="expanded = !expanded" />
    </q-card-section>
    <q-separator v-if="label || $slots.label" />
    <q-slide-transition :duration="800">
      <q-card-section v-if="expanded" :class="contentClass">
        <slot />
      </q-card-section>
    </q-slide-transition>
  </q-card>
</template>

<script setup>
import { ref, computed, provide, inject } from "vue"

const props = defineProps({
  bigTitle: Boolean,
  label: String,
  contentClass: String,
  expandable: Boolean,
  collapsedOnInit: Boolean,
  disable: Boolean,
  readonly: Boolean
})

const expanded = ref(!props.collapsedOnInit)

const parentFormDisabled = inject("formDisabled", ref(false))
provide(
  "formDisabled",
  computed(() => props.disable || parentFormDisabled.value)
)

const parentFormReadonly = inject("formReadonly", ref(false))
provide(
  "formReadonly",
  computed(() => props.readonly || parentFormReadonly.value)
)
</script>

<style lang="scss" scoped>
.title {
  background-color: $background;
}
</style>
